import React from 'react'
import styles from './panelIncluded.module.sass'

export type Exclusion = {
  count: number
  label: string
  detail: string
}

type Props = {
  // "156 people"
  included: string
  // "of 168 onboarded"
  of: string
  exclusions: Exclusion[]
  // Shown instead of the exclusions when there are none, if given.
  everyone?: string
}

// The "Who is included" block of an About this data panel.
export const PanelIncluded = ({ included, of, exclusions, everyone }: Props) => (
  <>
    <div className={styles.total}>
      <span className={styles.count}>{included}</span>
      <span className={styles.of}>{of}</span>
    </div>
    <Exclusions exclusions={exclusions} everyone={everyone} />
  </>
)

const Exclusions = ({ exclusions, everyone }: { exclusions: Exclusion[]; everyone?: string }) => {
  const shown = exclusions.filter((exclusion) => exclusion.count > 0)
  if (shown.length === 0 && !everyone) return null
  if (shown.length === 0) return <p className={styles.everyone}>{everyone}</p>

  const rows = shown.map((exclusion) => (
    <div key={exclusion.label} className={styles.exclusion}>
      <span className={styles.exclusionCount}>{exclusion.count}</span>
      <div className={styles.exclusionText}>
        <p className={styles.exclusionLabel}>{exclusion.label}</p>
        <p className={styles.exclusionDetail}>{exclusion.detail}</p>
      </div>
    </div>
  ))

  return <>{rows}</>
}
